/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Metadata_DescriptionInputs */

const en_common_metadata_description = /** @type {(inputs: Common_Metadata_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download and install CADCraft, ArtCraft's free open-source AutoCAD alternative. Compare it with Autodesk AutoCAD and learn it with hands-on tutorials.`)
};

/**
* | output |
* | --- |
* | "Download and install CADCraft, ArtCraft's free open-source AutoCAD alternative. Compare it with Autodesk AutoCAD and learn it with hands-on tutorials." |
*
* @param {Common_Metadata_DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const common_metadata_description = /** @type {((inputs?: Common_Metadata_DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Metadata_DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_common_metadata_description(inputs)
});
export { common_metadata_description as "common.metadata.description" }